/**
 * Throughline wordmark.
 * A serif-blended sans wordmark with a single continuous line running under the letterforms.
 * Monochrome, works at 16px+. No icon-with-name.
 */
export function Brand({ variant = "dark", size = 22, subtitle = false }) {
  const fg = variant === "dark" ? "#0F172A" : "#F8FAF9";
  const muted = variant === "dark" ? "#64748B" : "#94A3B8";
  return (
    <div className="inline-flex flex-col leading-none select-none">
      <svg viewBox="0 0 260 40" height={size} role="img" aria-label="Throughline" style={{ overflow: "visible" }}>
        <text
          x="0" y="28"
          fontFamily="Georgia, 'Times New Roman', serif"
          fontWeight="600" fontSize="30"
          letterSpacing="-1.2"
          fill={fg}
        >throughline</text>
        <line x1="0" y1="34" x2="200" y2="34" stroke={fg} strokeWidth="1" opacity="0.9" />
        <circle cx="200" cy="34" r="2" fill={fg} />
      </svg>
      {subtitle && (
        <div className="text-[9px] uppercase tracking-[0.2em] mt-1.5 font-semibold" style={{ color: muted }}>
          Housing Opportunity Infrastructure
        </div>
      )}
    </div>
  );
}

export function BrandMark({ size = 20, color = "#0F172A" }) {
  // Compact "th·" mark for tight nav / favicon-like usage
  return (
    <svg viewBox="0 0 40 32" height={size} width={size * 40 / 32} role="img" aria-label="Throughline">
      <text x="0" y="24" fontFamily="Georgia, serif" fontWeight="600" fontSize="26" letterSpacing="-1.5" fill={color}>th</text>
      <line x1="0" y1="28" x2="28" y2="28" stroke={color} strokeWidth="1.2" />
      <circle cx="28" cy="28" r="1.8" fill={color} />
    </svg>
  );
}
